// extracted by mini-css-extract-plugin
export default {"buttonReset":"globals_buttonReset__UZKXQ","image":"globals_image__s17yp","container":"globals_container__okg8u","responsiveImg":"globals_responsiveImg__m05zu"};